import type { GetArtistPagePodcastsQuery } from '#lib/websites/artists/queries/__generated__/getArtistPagePodcasts.generated.js';

export const transformInfiniteDataPodcasts = (
	data: GetArtistPagePodcastsQuery
) => {
	const artistPodcasts =
		data.Artists[0]?.podcast_episodes?.map(
			(episode) => episode?.HENI_Talks_Podcast_Episode_id
		) || [];

	return artistPodcasts;
};
